import './styles/_loyalty.scss';
import './styles/_loyaltylion.scss';
import { onDocumentReady } from '../utils/dom';
import { addItemsToCart } from '../services/cart';
import { updateEmail } from '../services/update-email';
import { updatePassword } from '../services/update-password';
import { updatePhone } from '../services/update-phone';
import { loginFunction, registerFunction } from '../services/auth';
import processFetchedData from '../services/loyalty-table';
import modalListener from '../services/password-modal';
import { loyaltyDiscount } from '../services/loyalty-discount';
import { buttonMutationObserver } from '../services/wishlist-mutation';
import { debounce } from '../utils/performance';

const state = {
    elements: {},
    SHOPIFY_STOREFRONT_URL: `https://${window.location.hostname}/`,
    SHOPIFY_STOREFRONT_TOKEN: document.getElementById('customer-email').dataset.token,
    SHOPIFY_STOREFRONT_GRAPHQL: `https://${window.location.hostname}/api/2023-07/graphql.json`,
};

window.localStorage.setItem("ShopifyStoreUrl", state.SHOPIFY_STOREFRONT_URL);
window.localStorage.setItem("ShopifyStorefrontToken", state.SHOPIFY_STOREFRONT_TOKEN);

const cacheState = () => {
    state.elements = {
        modalWrapper: document.querySelector(".ly-modal"),
        modalButtons: document.querySelectorAll(".ly-home__item--cta"),
        modalCloseBtn: document.querySelector(".ly-modal__header--icon"),
        modalHeaderTitle: document.querySelector(".ly-modal__header--title"),
        modalHeaderContent: document.querySelector(".ly-modal__header--content"),
        boxItems: document.querySelectorAll(".ly-home__item"),
        customerEmail: document.getElementById('customer-email')?.dataset.customerEmail,
        addressModals: document.querySelectorAll(".address__modal"),
        addAddressModals: document.querySelectorAll(".add__address--modal"),
        addressEditBtns: document.querySelectorAll(".address__edit"),
        addAddressBtns: document.querySelectorAll(".add__address"),
        cancelEditBtns: document.querySelectorAll(".address__cancel"),
        cancelAddBtns: document.querySelectorAll(".add--address__cancel"),
        deleteAddresses: document.querySelectorAll("button[data-confirm-message]"),
        contactUsCta: document.querySelector(".contact__us--cta"),
        accountCta: document.querySelector(".account--cta"),
        rewardsCta: document.querySelector(".rewards--cta"),
        ordersCta: document.querySelector(".orders--cta"),
        faqCta: document.querySelector(".faq--cta"),
        wishlistCta: document.querySelector(".wishlist--cta"),
        wishlistAccordion: document.querySelector(".wishlist--accordion"),
        contactUsAccordion: document.querySelector(".contact__us--accordion"),
        accountAccordion: document.querySelector(".account--accordion"),
        ordersAccordion: document.querySelector(".orders--accordion"),
        rewardsAccordion: document.querySelector(".rewards--accordion"),
        faqAccordion: document.querySelector(".faq--accordion"),
        expendedAccordions: document.querySelectorAll("expended-accordion"),
        registerWrapper: document.querySelector(".register-wrapper"),
        loginWrapper: document.querySelector(".ly-auth__login"),
        forgotPasswordBtn: document.querySelector(".ly-auth__forgot--password"),
        resetPasswordModal: document.querySelector(".reset-password-modal"),
        cancelResetBtn: document.querySelector(".cancel-reset-btn"),
        redirectLoginBtn: document.querySelector(".login__btn"),
        redirectRegisterBtn: document.querySelector(".register__btn"),
        wishlistMoveCarts: document.querySelectorAll(".wishlist-move-cart"),
        accordionWrapper: document.querySelector(".accordion__wrapper"),
        updateEmailButton: document.querySelector(".update_email_button"),
        updatePasswordButton: document.querySelector(".update_password_button"),
        updatePhoneButton: document.querySelector(".update_phone_button"),
        modalTypes: ['contactUs', 'account', 'rewards', 'orders', 'faq'],
    };
};

const toggleModal = () => {
    state.elements.expendedAccordions.forEach(accordion => {
        const header = accordion.querySelector(".accordion-item-header");
        header.style.display = 'flex';
        accordion.style.display = 'block';
    });
    state.elements.modalHeaderContent.style.display = 'block';
    state.elements.modalHeaderTitle.textContent = 'Rewards';
    state.elements.rewardsAccordion.classList.add("active");
    state.elements.modalWrapper.classList.toggle("open");
    state.elements.boxItems.forEach(item => item.style.visibility = 'visible');
};

const addressFun = (index) => {
    state.elements.addAddressModals.forEach(modal => modal.classList.remove('active'));
    state.elements.addressModals.forEach((modal, idx) => {
        if (index === idx) {
            modal.classList.toggle('active');
        }
    });
};

const addAddressFun = (index) => {
    state.elements.addressModals.forEach(modal => modal.classList.remove('active'));
    state.elements.addAddressModals.forEach((modal, idx) => {
        if (index === idx) {
            modal.classList.toggle('active');
        }
    });
};

const deleteAddress = ({ currentTarget }) => {
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
        Shopify.postLink(currentTarget.dataset.target, {
            parameters: { _method: 'delete' },
        });
    }
};

const ruleFunction = () => {
    document.addEventListener("click", (e) => {
        const rule = e.target.closest('.lion-rule-item--actionable');
        if (!rule) return;
        const button = rule.querySelector("button");
        button?.click();
    });
};

const voucherFunction = () => {
    document.addEventListener("click", (e) => {
        const voucher = e.target.closest('.lion-reward-item--customer');
        if (!voucher) return;
        const button = voucher.querySelector("button");
        button?.click();
    });
};

const fadeInModal = () => {
    state.elements.modalWrapper.classList.remove('hidden');
    state.elements.modalWrapper.classList.add('open');
};

const modalHandler = (modalType) => {
    const accordionMapping = {
        contactUs: state.elements.contactUsAccordion,
        account: state.elements.accountAccordion,
        rewards: state.elements.rewardsAccordion,
        orders: state.elements.ordersAccordion,
        faq: state.elements.faqAccordion,
        wishlist: state.elements.wishlistAccordion,
    };

    state.elements.boxItems.forEach(item => item.style.visibility = 'hidden');

    state.elements.expendedAccordions.forEach(accordion => {
        const header = accordion.querySelector(".accordion-item-header");
        header.style.display = 'none';
        accordion.classList.remove("active");
        accordion.style.display = 'none';
    });

    state.elements.modalHeaderContent.style.display = modalType === 'rewards' ? 'block' : 'none';
    state.elements.modalHeaderTitle.textContent = modalType.charAt(0).toUpperCase() + modalType.slice(1).replace('Us', ' Us');
    
    if (Array.isArray(accordionMapping[modalType])) {
        accordionMapping[modalType].forEach((acc, index) => {
            acc.style.display = 'block';
            if(index == 0){
                acc.classList.add("active");
            }
        });
    } else {
        accordionMapping[modalType].style.display = 'block';
        accordionMapping[modalType].classList.add("active");
    }

    if(modalType == 'wishlist'){
        state.elements.modalWrapper.style.background = 'rgb(227, 227, 227)';
    }else{
        state.elements.modalWrapper.style.background = 'rgba(227, 227, 227, 0.6)';
    }

    if(modalType == 'account' || modalType == 'faq'){
        state.elements.accordionWrapper.style.minHeight = '50vh';
    }else{
        state.elements.accordionWrapper.style.minHeight = '30vh';
    }

    fadeInModal();
};

const loginModal = () => {
    state.elements.registerWrapper.classList.toggle("visibility");
    state.elements.loginWrapper.classList.toggle("active");
};

const toggleLoginModal = () => {
    state.elements.loginWrapper.classList.toggle("display-none");
    state.elements.resetPasswordModal.classList.toggle("active");
};

const addToCart = () => {
    document.addEventListener("click", (e) => {
        const targetElement = e.target.closest('.wishlist-cart, .wishlist-move-cart');
        if (targetElement) {
            e.preventDefault();
            e.stopPropagation();

            const variant_id = targetElement.getAttribute('data-variant_id');
            const quantity = 1;

            const items = [
                {
                    id: variant_id,
                    quantity: quantity
                }
            ];

            targetElement.textContent = "Adding...";

            addItemsToCart(items).then(response => {
                if (response && !response.errors) {
                    targetElement.textContent = "Added to cart";
                } else {
                    targetElement.textContent = "Add to cart";
                    console.error(response.errors || 'Error adding item to cart');
                }
            }).catch(error => {
                targetElement.textContent = "Add to cart";
                console.error('Error:', error);
            }).finally(() => {
                setTimeout(() => {
                    targetElement.textContent = "Add to cart";
                }, 2000);
            });
        }
    });
};

function initScrollBehavior() {
    const containerAnimation = document.querySelector('.ly-animation');
    const wrapper = document.querySelector('.ly__wrapper');
    const membership = document.querySelector('.ly-membership');

    if (wrapper && membership) {
        let isFixed = false;
        const threshold = -containerAnimation.clientHeight;

        const debouncedHandleScroll = debounce(createHandleScroll(wrapper, membership, threshold, isFixed), 1);

        document.addEventListener('scroll', debouncedHandleScroll);
    } else {
        console.log('Either ly__wrapper or ly-membership element not found');
    }
}

function createHandleScroll(wrapper, membership, threshold, isFixed) {
    return function handleScroll() {
        const distanceFromTop = wrapper.getBoundingClientRect().top;

        if (distanceFromTop <= 0 && distanceFromTop > threshold && !isFixed) {
            setFixedPosition(membership, wrapper);
            isFixed = true;
        } else if (distanceFromTop > 0 || distanceFromTop <= threshold) {
            resetPosition(membership, distanceFromTop, threshold);
            isFixed = false;
        }
    };
}

function setFixedPosition(membership, wrapper) {
    membership.style.position = 'fixed';
    membership.style.top = '0';
    
    setTimeout(() => {
        const wrapperHeight = wrapper.offsetHeight;
        console.log('Wrapper height after fixing:', wrapperHeight);
    }, 0);
}

function resetPosition(membership, distanceFromTop, threshold) {
    if (distanceFromTop <= threshold) {
        membership.style.position = 'sticky';
        membership.style.top = '0';
    } else {
        membership.style.position = '';
        membership.style.top = '';
    }
}


const attachEventListeners = () => {
    state.elements.redirectLoginBtn?.addEventListener("click", loginModal);
    state.elements.redirectRegisterBtn?.addEventListener("click", loginModal);
    state.elements.forgotPasswordBtn?.addEventListener("click", toggleLoginModal);
    state.elements.cancelResetBtn?.addEventListener("click", toggleLoginModal);
    state.elements.modalButtons.forEach(button => {
        button?.addEventListener("click", toggleModal);
    });
    state.elements.modalCloseBtn?.addEventListener("click", toggleModal);
    state.elements.addressEditBtns.forEach((btn, index) => {
        btn?.addEventListener("click", () => addressFun(index));
    });
    state.elements.addAddressBtns.forEach((btn, index) => {
        btn?.addEventListener("click", () => addAddressFun(index));
    });
    state.elements.cancelEditBtns.forEach((btn, index) => {
        btn?.addEventListener("click", () => addressFun(index));
    });
    state.elements.cancelAddBtns.forEach((btn, index) => {
        btn?.addEventListener("click", () => addAddressFun(index));
    })
    state.elements.deleteAddresses.forEach(btn => {
        btn.addEventListener("click", deleteAddress);
    });
    state.elements.updateEmailButton?.addEventListener("click", updateEmail);
    state.elements.updatePasswordButton?.addEventListener("click", updatePassword);
    state.elements.updatePhoneButton?.addEventListener("click", updatePhone);
    state.elements.modalTypes?.forEach((type) => {
        const element = state.elements[`${type}Cta`];
        element?.addEventListener("click", () => modalHandler(type));
    });
    state.elements.wishlistCta?.addEventListener("click", () => {
        const wishlistInput = document.querySelector('[data-wishlist-input]');
        const wishlistItems = document.querySelectorAll(".wishlist-column");

        if (!wishlistItems.length && wishlistInput) {
            const event = new Event('input', {
                bubbles: true,
                cancelable: true,
            });
            wishlistInput.dispatchEvent(event);
        }
        modalHandler('wishlist');
    });
};

const init = () => {
    addToCart();
    cacheState();
    attachEventListeners();
    ruleFunction();
    voucherFunction();
    processFetchedData();
    loyaltyDiscount();
    loginFunction();
    registerFunction();
    modalListener();
    buttonMutationObserver();
    initScrollBehavior();
};

onDocumentReady(init);